module.exports = __webpack_public_path__ + "img/cross.3cdea3bc.svg";